module.exports = __webpack_public_path__ + "static/media/paolo.7a1bff7f.jpg";